export default __webpack_public_path__ + "static/media/parking.49b3f23f.svg";